export const append = (buttonElement) => {
  buttonElement
    .append("rect")
    // use this to select the "rect", "ellipse" and "image" part of a button
    .classed("dashboard-button", true)
    // use this to select the button without its shadow
    .classed("dashboard-button-main", true)
    // use this to select the "rect" part of the button, including its shadow
    .classed("dashboard-button-rect", true)
    .style("fill", "white")
    .style("display", "none")
    .style("stroke-width", 1)
    .style("stroke", "black")
    .attr("rx", 8)
    .attr("ry", 8)
  computeAttributes(buttonElement)
}

export const computeAttributes = (buttonElement) => {
  const datum = buttonElement.datum()
  buttonElement
    .selectAll(".dashboard-button-rect")
    .attr("width", datum.width)
    .attr("height", datum.height)
}
